// Modules
require('./news/js/news');
require('./solr/js/solr');
